// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__m8HQR","label":"Radio_label__15uxm","checkMark":"Radio_checkMark__1i7nq","disabled":"Radio_disabled__3kL5f"};